module.exports = __webpack_public_path__ + "static/img/1_2_1.994a91c1.jpg";